import React, { useState, useEffect, useCallback, useContext } from 'react'
import PropTypes from 'prop-types'
import { StoreDispatch } from '../../Store'

// Components
import ScrollSection from '../ScrollSection'
import MapIntro from './MapIntro'
import MapNav from './MapNav'
import MapRoutes from './MapRoutes'
import { scrollToId } from '../../utils/utils'

const Map = props => {
  const [mapIndex, setMapIndex] = useState(0)

  const dispatch = useContext(StoreDispatch)

  const scrollToMap = () => {
    let mapSection = document.querySelector('#map')

    if (!mapSection) return

    let distance = mapSection.getBoundingClientRect().top

    if (distance < 200) return

    scrollToId('map', dispatch)
  }

  const update = useCallback(() => {
    if (mapIndex > -1) {
      setMapIndex(-1)
    }
  }, [mapIndex, setMapIndex])

  useEffect(() => {
    window.addEventListener('resize', update)

    return () => {
      window.removeEventListener('resize', update)
    }
  }, [update])

  return (
    <ScrollSection>
      <MapIntro
        id={`${props.id}-intro`}
        heading={props.heading}
        text={props.text}
        link={props.link}
      />
      <MapNav
        id={`${props.id}-nav`}
        mapIndex={mapIndex}
        setMapIndex={setMapIndex}
        scrollToMap={scrollToMap}
        {...props}
      />
      <MapRoutes
        id={`${props.id}-routes`}
        mapIndex={mapIndex}
        fallbackBegin={mapIndex === -1 ? () => setMapIndex(0) : null}
      />
    </ScrollSection>
  )
}

Map.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.object.isRequired,
  text: PropTypes.object,
  link: PropTypes.string,
  section1Dates: PropTypes.string,
  section1Title: PropTypes.object,
  section1Copy: PropTypes.string,
  section2Dates: PropTypes.string,
  section2Title: PropTypes.object,
  section2Copy: PropTypes.string,
  section3Dates: PropTypes.string,
  section3Title: PropTypes.object,
  section3Copy: PropTypes.string,
  section4Dates: PropTypes.string,
  section4Title: PropTypes.object,
  section4Copy: PropTypes.string,
}

export default Map
